<template>
  <Modal
    :value="value"
    @hide="hide()"
    title="Unseal vault"
    :skipCloseOnBgClick="true"
  >
    <template slot="body" class="content">
      <BArea
        :name="area.name"
        :validation="area.validation"
        :icon="area.icon"
        :type="area.type"
        :placeholder="area.placeholder"
        v-model="area.value"
        @valid="valid = $event"
      ></BArea>
    </template>
    <template slot="footer" class="content">
      <div
        :disabled="!valid || isLoading"
        :class="{ 'is-loading': isLoading }"
        class="button is-primary"
        @click="unseal()"
      >
        Unseal
      </div>
      <div class="button" @click="hide()">Close</div>
    </template>
  </Modal>
</template>

<script>
import { postApi } from "@/utils/http";
import { reroute } from "@/utils/auth";

export default {
  props: {
    value: Boolean
  },
  components: {
    BArea: () => import("@/components/singles/BArea/component.vue"),
    Modal: () => import("@/components/main/Modal.vue")
  },

  data() {
    return {
      isLoading: false,

      valid: false,
      area: {
        icon: "mdi-lock",
        name: "keys",
        placeholder: "One key per line",
        type: "text",
        label: null,
        validation: "required",
        value: "",
        focus: true
      }
    };
  },
  created() {},
  mounted() {},
  methods: {
    async unseal() {
      if (this.valid) {
        try {
          this.isLoading = true;
          const res = await postApi(
            "unseal",

            {
              keys: this.area.value
                .split("\n")
                .filter(x => x != "")
                .map(x => x.trim())
            },
            { skipDataObject: true, skipAuth: true, fullDataObject: true }
          );

          const status = res.status;
          if (status === 202) {
            this.$helpers.notify(
              "Partial unsealed",
              `Need ${res.data.left} more ${
                res.data.left > 1 ? "keys" : "key"
              } to unseal the vault.`,
              "success"
            );
          } else if (status === 200) {
            this.$helpers.notify(
              "Success",
              "Unsealing the vault is complete.",
              "success"
            );

            this.$store.commit("settings/setServer", {
              ...this.$store.state.settings.server,
              sealed: false
            });

            reroute();
          }
        } catch ({ response }) {
          if (response.status === 400) {
            this.$helpers.notify(
              "Missing keys",
              "The server did not receive any keys.",
              "warning"
            );
          } else if (response.status === 401) {
            this.$helpers.notify("Incorrect", "Incorrect keys.", "warning");
          } else {
            this.$helpers.notify("Error", "Internal server error.", "danger");
          }
        }

        this.isLoading = false;
      }
    },
    hide() {
      this.$emit("hide", false);
      this.$emit("input", false);
    }
  }
};
</script>
